import { useCurrency } from '../../context/CurrencyContext';

export const CurrencySelector = () => {
  const { currency, setCurrency, currencies } = useCurrency();

  return (
    <div className="flex items-center gap-1 bg-white/[0.04] rounded-lg p-1" data-testid="currency-selector">
      {currencies.map((cur) => (
        <button
          key={cur}
          onClick={() => setCurrency(cur)}
          className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
            currency === cur
              ? 'bg-brand-green text-white'
              : 'text-neutral-400 hover:text-white hover:bg-white/[0.08]'
          }`}
          data-testid={`currency-${cur}`}
        >
          {cur}
        </button>
      ))}
    </div>
  );
};
